module.exports = __webpack_public_path__ + "media/images/video-conf-582423d337d68ef2b7937fdca2aade9780d2efd6c6dec9dddd334422be57cab5.jpg";